import PlatformSettings from './PlatformSettings';
import PortalSettings from './PortalSettings';

export {
  PlatformSettings,
  PortalSettings,
};


// WEBPACK FOOTER //
// ./src/views/ConvertLeads/components/index.js